const list = [
    { 'enums': 'WhatProgramTypeMM', 'value': 7 },
    { 'enums': 'WhatProgramTypeMB', 'value': 67 },
    { 'enums': 'WhatLevel', 'value': 68 },
    { 'enums': 'PostBACOrPrepa', 'value': 71 },
    { 'enums': 'WhatSpecMM', 'value': 10 },
    { 'enums': 'WhatSpecMB', 'value': 69 },
    { 'enums': 'OtherSpec', 'value': 11 },
]
export const enums = list.reduce(function(result, item, index) {
  result[item.enums] = item.value;
  return result;
}, {})
export const getList = list.map(({value, title}) => {return {value, title}})
export const getTitle = (findValue) => {
  if(!findValue) return null
  return list.find(({value}) => value === findValue).title
}

